import { Expose } from "@nts/std/serialization";

export class ServiceDataObjectDto {
    
    @Expose()
    public objectName: string;

}